<template>
  <div
    v-if="hide_menu"
    class="absolute top-[15%] z-[60] bg-blues p-2 lg:hidden cursor-pointer h-[40px] rounded-r-xl"
    @click="toggleMenu"
  >
    <!-- <div class="pl-2">
      <div class="bg-white w-6 mt-1 h-1 rounded-lg"></div>
      <div class="bg-white w-6 mt-1 h-1 rounded-lg"></div>
      <div class="bg-white w-6 mt-1 h-1 rounded-lg"></div>
    </div> -->
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="20"
      height="20"
      viewBox="0 0 50 50"
      fill="#fff"
    >
      <path
        d="M 0 7.5 L 0 12.5 L 50 12.5 L 50 7.5 Z M 0 22.5 L 0 27.5 L 50 27.5 L 50 22.5 Z M 0 37.5 L 0 42.5 L 50 42.5 L 50 37.5 Z"
      ></path>
    </svg>
  </div>

  <div
    class="lg:flex fixed w-[95%] bg-white lg:w-[35%] lg:left-0 overflow-y-auto xl:w-[30%] 2xl:w-[25%] lg:relative z-30 mt-10 lg:m-10 rounded-3xl heightfix transition-all duration-300"
    :class="{ hidden: !isMobile }"
    style="box-shadow: 0px 2px 30px 0px #01b0f926"
  >
    <div
      @click="toggleSidebar"
      class="absolute top-2 right-[2px] z-30 block lg:hidden bg-gray-200 rounded-full p-1 cursor-pointer"
    >
      <!-- <span class="text-2xl">⬅️</span> -->
      <img src="@/assets/leftaaa.svg" alt="" srcset="" class="w-5 h-5" />
    </div>
    <div class="flex flex-col gap-4 w-full p-5 2xl:p-10">
      <div class="sticky top-0 z-10 bg-white border-b pb-4">
        <div class="flex items-start gap-3">
          <!-- Icon -->
          <div class="bg-blue-100 p-2 rounded-xl flex-shrink-0 mt-1">
            <!-- <img src="@/assets/newd/icons/Book.png" class="w-5 h-5" /> -->
          </div>

          <!-- Text -->
          <div class="min-w-0">
            <h2 class="text-sm font-bold text-gray-800 break-words">
              {{ courseTitle }}
            </h2>
            <p class="text-xs text-gray-500">Active Course</p>
          </div>
        </div>
      </div>
      <div class="flex flex-col gap-5 relative w-full overflow-y-auto h-full">
        <router-link
          :to="{ name: 'StudentCourseProgress' }"
          class="flex items-center gap-5 p-4 rounded-3xl transition-all duration-200"
          :class="{
            'bg-[#0085DB] text-white': $route.name == 'StudentCourseProgress',
            'hover:bg-gray-100 text-[#333333]':
              $route.name != 'StudentCourseProgress',
          }"
        >
          <svg
            class="w-5 h-5 flex-shrink-0"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
            <path
              d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"
            />
            <path d="M12 6h4M12 10h4M12 14h4" />
          </svg>
          <p class="font-bold text-xs">Lessons</p>
        </router-link>

        <!-- <router-link
        :to="{ name: 'StudentMessages' }"
        class="flex items-center gap-5 p-4 rounded-3xl hidden"
        :class="{ 'bg-[#0085DB]': $route.name == 'StudentMessages','hover:bg-gray-100': $route.name != 'StudentMessages'}"
      >
        <img
          src="@/assets/newd/icons/mdi-light_forum-1.png"
          v-if="$route.name == 'StudentMessages'"
          alt=""
        />
        <img
          src="@/assets/newd/icons/mdi-light_forum.png"
          v-if="$route.name != 'StudentMessages'"
          alt=""
        />

        <p
          class="font-bold text-xs"
          :class="{
            'text-white': $route.name == 'StudentMessages',
            'text-[#333333]': $route.name != 'StudentMessages',
          }"
        >
          Messages
        </p>
      </router-link> -->

        <router-link
          v-if="checkinTheList('Messages')"
          :to="{ name: 'StudentNewMessages' }"
          class="flex items-center gap-5 p-4 rounded-3xl transition-all duration-200"
          :class="{
            'bg-[#0085DB] text-white': $route.name == 'StudentNewMessages',
            'hover:bg-gray-100 text-[#333333]':
              $route.name != 'StudentNewMessages',
          }"
        >
          <div class="flex items-center gap-5">
            <svg
              class="w-5 h-5 flex-shrink-0"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
              />
            </svg>
            <p class="font-bold text-xs">Messages</p>
          </div>
        </router-link>

        <router-link
          v-if="checkinTheList('Assignments')"
          :to="{ name: 'StudentAssignments' }"
          class="flex items-center gap-5 p-4 rounded-3xl transition-all duration-200"
          :class="{
            'bg-[#0085DB] text-white': assignMentActive,
            'hover:bg-gray-100 text-[#333333]': !assignMentActive,
          }"
        >
          <svg
            class="w-5 h-5 flex-shrink-0"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
            />
            <polyline points="14 2 14 8 20 8" />
          </svg>
          <p class="font-bold text-xs">Assignments</p>
        </router-link>

        <router-link
          v-if="checkinTheList('Homework')"
          :to="{ name: 'StudentHomeWorks' }"
          class="flex items-center gap-5 p-4 rounded-3xl hidden"
          :class="{
            'bg-[#0085DB]': homeWorkActive,
            'hover:bg-gray-100': !homeWorkActive,
          }"
        >
          <img
            src="@/assets/newd/icons/Calendar2Week-1.png"
            v-if="homeWorkActive"
            alt=""
          />
          <img
            src="@/assets/newd/icons/Calendar2Week.png"
            v-if="!homeWorkActive"
            alt=""
          />

          <p
            class="font-bold text-xs"
            :class="{
              'text-white': homeWorkActive,
              'text-[#333333]': !homeWorkActive,
            }"
          >
            Homework
          </p>
        </router-link>

        <!-- old forums -->
        <router-link
          v-if="checkinTheList('Messages')"
          :to="{ name: 'StudentForums' }"
          class="flex items-center gap-5 p-4 rounded-3xl hidden"
          :class="{
            'bg-[#0085DB]': $route.name == 'StudentForums',
            'hover:bg-gray-100': $route.name != 'StudentForums',
          }"
        >
          <img
            src="@/assets/newd/icons/Archive-1.png"
            v-if="$route.name == 'StudentForums'"
            alt=""
          />
          <img
            src="@/assets/newd/icons/Archive.png"
            v-if="$route.name != 'StudentForums'"
            alt=""
          />

          <p
            class="font-bold text-xs"
            :class="{
              'text-white': $route.name == 'StudentForums',
              'text-[#333333]': $route.name != 'StudentForums',
            }"
          >
            Forums
          </p>
        </router-link>

        <!-- new forums -->
        <router-link
          v-if="checkinTheList('Messages')"
          :to="{ name: 'StudentNewForums' }"
          class="flex items-center gap-5 p-4 rounded-3xl transition-all duration-200"
          :class="{
            'bg-[#0085DB] text-white': $route.name == 'StudentNewForums',
            'hover:bg-gray-100 text-[#333333]':
              $route.name != 'StudentNewForums',
          }"
        >
          <svg
            class="w-5 h-5 flex-shrink-0"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"
            />
          </svg>
          <p class="font-bold text-xs">Forums</p>
        </router-link>

        <router-link
          :to="{ name: 'StudentClasses' }"
          class="flex items-center gap-5 p-4 rounded-3xl transition-all duration-200"
          :class="{
            'bg-[#0085DB] text-white': $route.name == 'StudentClasses',
            'hover:bg-gray-100 text-[#333333]': $route.name != 'StudentClasses',
          }"
        >
          <svg
            class="w-5 h-5 flex-shrink-0"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            xmlns="http://www.w3.org/2000/svg"
          >
            <polygon points="23 7 16 12 23 17 23 7" />
            <rect x="1" y="5" width="15" height="14" rx="2" ry="2" />
          </svg>
          <p class="font-bold text-xs">Live Classes</p>
        </router-link>

        <router-link
          v-if="checkinTheList('Assessment')"
          :to="{ name: 'StudentAssessments' }"
          class="flex items-center gap-5 p-4 rounded-3xl transition-all duration-200"
          :class="{
            'bg-[#0085DB] text-white': $route.name == 'StudentAssessments',
            'hover:bg-gray-100 text-[#333333]':
              $route.name != 'StudentAssessments',
          }"
        >
          <svg
            class="w-5 h-5 flex-shrink-0"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            xmlns="http://www.w3.org/2000/svg"
          >
            <polygon points="12 2 2 7 12 12 22 7 12 2" />
            <polyline points="2 17 12 22 22 17" />
            <polyline points="2 12 12 17 22 12" />
          </svg>
          <p class="font-bold text-xs">Assessment</p>
        </router-link>

        <router-link
          v-if="checkinTheList('Exams/Results')"
          :to="{ name: 'StudentReport' }"
          class="flex items-center gap-5 p-4 rounded-3xl hidden"
          :class="{
            'bg-[#0085DB]': $route.name == 'StudentReport',
            'hover:bg-gray-100': $route.name != 'StudentReport',
          }"
        >
          <img
            src="@/assets/newd/icons/CloudArrowDown-1.png"
            v-if="$route.name == 'StudentReport'"
            alt=""
          />
          <img
            src="@/assets/newd/icons/CloudArrowDown.png"
            v-if="$route.name != 'StudentReport'"
            alt=""
          />

          <p
            class="font-bold text-xs"
            :class="{
              'text-white': $route.name == 'StudentReport',
              'text-[#333333]': $route.name != 'StudentReport',
            }"
          >
            Reports
          </p>
        </router-link>

        <router-link
          v-if="checkinTheList('Projects')"
          :to="{ name: 'StudentProject' }"
          class="flex items-center gap-5 p-4 rounded-3xl"
          :class="{
            'bg-[#0085DB]': $route.name == 'StudentProject',
            'hover:bg-gray-100': $route.name != 'StudentProject',
          }"
        >
          <img
            src="@/assets/newd/icons/gg_notes-1.png"
            v-if="$route.name == 'StudentProject'"
            alt=""
          />
          <img
            src="@/assets/newd/icons/gg_notes.png"
            v-if="$route.name != 'StudentProject'"
            alt=""
          />
          <p
            class="font-bold text-xs"
            :class="{
              'text-white': $route.name == 'StudentProject',
              'text-[#333333]': $route.name != 'StudentProject',
            }"
          >
            Projects
          </p>
        </router-link>
        <!-- <router-link
        :to="{ name: 'HtmlStudentpageRender' }"
        class="flex items-center gap-5 p-4 rounded-3xl"
        :class="{
          'bg-[#0085DB]': $route.name == 'HtmlStudentpageRender',
          'hover:bg-gray-100': $route.name != 'HtmlStudentpageRender',
        }"
      >
        <img
          src="@/assets/newd/icons/gg_notes-1.png"
          v-if="$route.name == 'HtmlStudentpageRender'"
          alt=""
        />
        <img
          src="@/assets/newd/icons/gg_notes.png"
          v-if="$route.name != 'HtmlStudentpageRender'"
          alt=""
        />
        <p
          class="font-bold text-xs"
          :class="{
            'text-white': $route.name == 'HtmlStudentpageRender',
            'text-[#333333]': $route.name != 'HtmlStudentpageRender',
          }"
        >
          Mindspan
        </p>
      </router-link> -->

        <!-- Tickets -->
        <!-- Tickets -->
        <a
          href="https://sis.allianceonline.edu.in/"
          target="_blank"
          rel="noopener noreferrer"
          class="flex items-center gap-5 p-4 rounded-3xl bg-white hover:bg-gray-100 text-[#333333] transition-colors duration-200"
        >
          <svg
            class="w-5 h-5 flex-shrink-0"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            xmlns="http://www.w3.org/2000/svg"
          >
            <!-- Perfect ticket stub with distinct side cutout notches -->
            <path
              d="M3 7a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v3a2 2 0 1 0 0 4v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-3a2 2 0 1 0 0-4V7z"
            />
            <!-- Clean, non-blurry dashboard entry lines -->
            <path d="M9 12h6" />
            <path d="M12 9v6" />
          </svg>
          <p class="font-bold text-xs">Tickets</p>
        </a>

        <!-- Semester Exam -->
        <a
          href="https://au-exams.galecta.com"
          target="_blank"
          rel="noopener noreferrer"
          class="flex items-center gap-5 p-4 rounded-3xl bg-white hover:bg-gray-100 text-[#333333] transition-colors duration-200"
        >
          <svg
            class="w-5 h-5 flex-shrink-0"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            xmlns="http://www.w3.org/2000/svg"
          >
            <!-- Clean Top Diamond Cap -->
            <path d="M12 3L2 8l10 5 10-5-10-5z" />
            <!-- Underneath Skull Band Headpiece -->
            <path d="M6 10v4c0 3.31 2.69 6 6 6s6-2.69 6-6v-4" />
            <!-- Explicit Tassel Hanging From The Right Corner -->
            <path d="M22 8v8" />
          </svg>
          <p class="font-bold text-xs">Semester Exam</p>
        </a>
        <router-link
          v-if="checkinTheList('Projects')"
          :to="{ name: 'GradBook' }"
          class="flex items-center gap-5 p-4 rounded-3xl"
          :class="{
            'bg-[#0085DB]': $route.name == 'GradBook',
            'hover:bg-gray-100': $route.name != 'GradBook',
          }"
        >
          <img
            src="@/assets/newd/icons/gg_notes-1.png"
            v-if="$route.name == 'GradBook'"
            alt=""
          />
          <img
            src="@/assets/newd/icons/gg_notes.png"
            v-if="$route.name != 'GradBook'"
            alt=""
          />
          <p
            class="font-bold text-xs"
            :class="{
              'text-white': $route.name == 'GradBook',
              'text-[#333333]': $route.name != 'GradBook',
            }"
          >
            Grad Book
          </p>
        </router-link>
        <!-- <router-link
        :to="{ name: 'codingView', params: { course_id: 123 } }"
        class="flex items-center gap-5 p-4 rounded-3xl"
        :class="{
          'bg-[#0085DB]': $route.name == 'codingView',
          'hover:bg-gray-100': $route.name != 'codingView',
        }"
      >
        <img
          src="@/assets/newd/icons/gg_notes-1.png"
          v-if="$route.name == 'codingView'"
          alt=""
        />
        <img
          src="@/assets/newd/icons/gg_notes.png"
          v-if="$route.name != 'codingView'"
          alt=""
        />
        <p
          class="font-bold text-xs"
          :class="{
            'text-white': $route.name == 'codingView',
            'text-[#333333]': $route.name != 'codingView',
          }"
        >
          Coding
        </p>
      </router-link> -->
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      isMobile: false,
      hide_menu: true,
      permisson_list: [],
      courseTitle: "",
      course_id: null,
    };
  },

  computed: {
    ...mapGetters(["isAuthenticated", "userInfo", "permissionList"]),

    assignMentActive() {
      return (
        this.$route.name == "StudentAssignments" ||
        this.$route.name == "AssignmentDetail"
      );
    },

    homeWorkActive() {
      return (
        this.$route.name == "StudentHomeWorks" ||
        this.$route.name == "StudentHomeworkDetail"
      );
    },
    routeParams() {
      console.log("course_id", this.$route.params.course_id);
      return {
        course_id: this.$route.params.course_id,
      };
    },
  },

  created() {
    // this.getFeaturesPermisson();
  },
  watch: {
    "$route.params.course_id"(newId) {
      if (!newId) {
        this.courseTitle = "";
        return;
      }

      this.fetchCourseTitle();
    },
  },
  mounted() {
    this.fetchCourseTitle();
  },
  methods: {
  async fetchCourseTitle() {
  const id = this.$route.params.course_id;

  if (!id) {
    this.courseTitle = "";
    return;
  }

  const storageKey = "courseTitle";

  const storedData = localStorage.getItem(storageKey);

  if (storedData) {
    try {
      const data = JSON.parse(storedData);

      if (data.id == id) {
        this.courseTitle = data.title;
        return;
      }
    } catch (e) {
      localStorage.removeItem(storageKey);
    }
  }

  try {
    const resp = await axios.get(
      `${process.env.VUE_APP_API}/courses/title/`,
      {
        params: {
          Key: this.userInfo.token_key,
          id: id,
        },
      },
    );

    if (resp.data.status === 200) {
      const title = resp.data.data?.[0]?.title || "Untitled Course";

      this.courseTitle = title;

      // Replace old course with new course
      localStorage.setItem(
        storageKey,
        JSON.stringify({
          id,
          title,
        })
      );
    }
  } catch (err) {
    console.error("Course fetch error:", err);
  }
},
    checkinTheList(feature) {
      // let bool = false;
      let check = this.permissionList.find((x) => x === feature);
      if (check != undefined) {
        return true;
      } else {
        return false;
      }
    },

    toggleSidebar() {
      this.isMobile = false;
      this.hide_menu = true;
    },
    toggleMenu() {
      this.isMobile = !this.isMobile;
      this.hide_menu = !this.isMobile; // Hide button when menu is open
    },

    // async getFeaturesPermisson() {
    //   await axios
    //     .get(
    //       `${process.env.VUE_APP_API}/features/?Key=${this.userInfo.token_key}`
    //     )
    //     .then((resp) => {
    //       if (resp.data.code == 200) {
    //       this.permisson_list = resp.data.message[0].features;
    //         // this.user_count = resp.data.user_count;
    //       }
    //     });
    // },
  },
};
</script>

<style scoped>
img {
  width: 20px;
  height: 20px;
}

.heightfix {
  height: calc(100vh - 170px) !important;
}
</style>
